import { motion } from 'framer-motion';
import { Brain, Target, Cpu, Clock } from 'lucide-react';

const benefits = [
  {
    icon: Brain,
    title: 'Holistic Insights',
    description: 'Gain a complete view of your traits and emotions and how they interact.'
  },
  {
    icon: Target,
    title: 'Actionable Strategies',
    description: 'Receive personalized growth plans aligned with your goals.'
  },
  {
    icon: Cpu,
    title: 'AI-Driven Precision',
    description: 'Leverage advanced algorithms for tailored feedback and recommendations.'
  },
  {
    icon: Clock,
    title: 'Time-Tested Frameworks',
    description: 'Rooted in proven psychological principles and breakthrough techniques.'
  }
];

export function BenefitsSection() {
  return (
    <section id="benefits" className="py-20 px-4">
      <div className="w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 w-full"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose The Personality Breakthrough Profile?
          </h2>
          <p className="text-gray-600 text-lg w-full">
            Whether you're a life coach or personal development enthusiast, our assessment
            offers unparalleled benefits.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 w-full">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-3xl shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`p-10 h-full min-h-[280px] ${
                index === 0 ? 'bg-blue-50 border-blue-100' :
                index === 1 ? 'bg-emerald-50 border-emerald-100' :
                index === 2 ? 'bg-purple-50 border-purple-100' :
                'bg-amber-50 border-amber-100'
              } rounded-3xl`}>
                <div className="flex items-start gap-4">
                  <benefit.icon className={`w-10 h-10 flex-shrink-0 mt-1 ${
                    index === 0 ? 'text-blue-600' :
                    index === 1 ? 'text-emerald-600' :
                    index === 2 ? 'text-purple-600' :
                    'text-amber-600'
                  }`} />
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}